import * as React from 'react';
import { contact, emptyContact } from '../../../model/contact';
import { IChatMessage } from '../../../model/chatmessage';
import { ListMessages } from './ListMessages';
import { Guid } from 'guid-typescript';
import { profile } from '../../../model/profile';
import Paper from '../../../ui-components/Containers/Paper';
import { styles } from '../styles';
import { WriteYourMessage } from './WriteYourMessage';

interface IProps {
    contact: contact;
    addMessage: (chatmessage: IChatMessage) => void;
    chatMessages: Array<IChatMessage>;
    profile: profile;
    smallScreen: boolean;
    classes: any;
    messageContainerHeigth: string;
    messageBoxRef: any;
}

interface IState {
    messageOut: string;
    myConnectionId: string;
    chatmessage: IChatMessage;
}

export class ChatBox extends React.Component<IProps, IState> {

    messagesEnd: HTMLDivElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            messageOut: ``,
            myConnectionId: ``,
            chatmessage: {
                _id: ``,
                createdAt: null,
                text: ``,
                fromAdmin: true,
                user: undefined
            },
        }
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    private sendMessage = () => {
        if (this.state.messageOut && this.state.messageOut.trim()) {
            if (this.props.contact.sub) {
                console.log('Admin sta per mandare il messaggio con Testo....:' + this.state.messageOut + ' ad utente con Sub:' + this.props.contact.sub);

                const newmessage: IChatMessage = {
                    _id: Guid.create().toString(),
                    text: this.state.messageOut,
                    createdAt: new Date(),
                    user: { _id: this.props.contact.sub },  // il sub del destinatario
                    fromAdmin: true
                }
                this.props.addMessage(newmessage);

            } else {
                console.error('Admin vorrebbe mandare il messaggio con Testo:' + this.state.messageOut + ' ma non abbiamo il suo Sub')
            }
            // Pulizia del campo dopo l'invio
            this.setState({ messageOut: `` })
        }
    }

    private handleChangeMessage = (event: any) => {
        this.setState({ messageOut: event.target.value })
    }

    scrollToBottom = () => {
        if (this.messagesEnd)
            this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.sendMessage();
        }
    }

    render() {
        let contact = this.props.contact ? this.props.contact : emptyContact();
        return (<>
            <Paper ref_={this.props.messageBoxRef}
                title={contact.name ? `${contact.name} ${contact.surname}` : contact.email}
                fullHeight id='chatBoxContainer'
                contentContainerStyle={styles(undefined).chatBox.contentContainerStyle}
                // containerStyle={{ height: `${this.props.messageContainerHeigth}`}}>
                containerStyle={{ height: `700px`, backgroundColor: "#e6e6e6" }}>
                <ListMessages
                    sub={contact.sub}
                    chatMessages={this.props.chatMessages} />
                <div style={{ float: "left", clear: "both" }}
                    ref={(el) => { this.messagesEnd = el; }}>
                </div>
            </Paper>
            <WriteYourMessage {...this.props} />
        </>
        )
    }
}
